<div class="container" [id]="data?.details?.id">
  <div
    class="row text-center text-md-start mt-5"
    [dir]="language == 'ar' ? 'rtl' : 'ltr'"
  >
    <h3>
      {{ data.details.title.split(" ")[0] }}
      <span> {{ data.details.title.split(" ").slice(1).join(" ") }}</span>
    </h3>
    <div
      class="col-12 col-sm-6 col-md-4"
      *ngFor="let item of data.details.services"
    >
      <!-- Use anchor tag for navigation -->
      <div class="">
        <a
          [href]="getDetailsUrl(item)"
          *ngIf="data.details.isDetails"
          [attr.style]="
            'text-decoration: none; color: inherit; display: block;'
          "
        >
          <img
            src="{{ item.imageIconPath }}"
            alt="{{ item.imageAlt }}"
            class=""
          />

          <div class="title" [dir]="language == 'ar' ? 'rtl' : 'ltr'">
            {{ item.titleTr }}
          </div>
          <p
            class="discreption"
            [dir]="language == 'ar' ? 'rtl' : 'ltr'"
            [innerHTML]="item.summary"
          ></p>
        </a>
        <!-- Content for non-navigable items -->
        <div *ngIf="!data.details.isDetails">
          <img
            *ngIf="item.imageIconPath"
            src="{{ item.imageIconPath }}"
            alt="{{ item.imageAlt }}"
            class=""
          />
          <div class="title" [dir]="language == 'ar' ? 'rtl' : 'ltr'">
            {{ item.titleTr }}
          </div>
          <p
            class="discreption"
            [dir]="language == 'ar' ? 'rtl' : 'ltr'"
            [innerHTML]="item.summary"
          ></p>
        </div>
      </div>
    </div>
  </div>
</div>
